import { useTranslation } from "react-i18next";
import { dateFormatter } from "project-config/utils/date-formatter";
import styled from "styled-components";
import { IBillingMessageInfoItem } from "./useInitNotification";
import { NotificationTabType } from "../constants";
import { useGlobalStore } from "@/store/GlobalStore";
import { useNotificationStore } from "../store/notification-store";
import { Operation, OperationButton } from "@/components/operation-button";

interface NotificationStyleProps {
  isRead: boolean;
}
const NotificationContent = styled.div<NotificationStyleProps>`
  color: ${(props) =>
    props.isRead ? "rgba(255, 255, 255, 0.35)" : "rgba(255, 255, 255, 0.85)"};
`;
const NotificationMonthContent = styled(
  NotificationContent
)<NotificationStyleProps>`
  cursor: pointer;
  padding-left: 14px;
  &::before {
    content: "";
    position: absolute;
    border-radius: 50%;
    width: 6px;
    height: 6px;
    background: var(--main-color);
    left: 16px;
    top: 18px;
    display: ${(props) => (props.isRead ? "none" : "block")};
  }
`;

export function useGetBillingMessageTable() {
  const { t } = useTranslation("notification");
  const { isZh } = useGlobalStore();
  const { currentNotificationTab } = useNotificationStore();

  const getBillContentKey =
    currentNotificationTab === NotificationTabType.BillingMessage
      ? "billMonth"
      : isZh
      ? "message"
      : "messageExtend";
  const columns = [
    {
      title: t("notification_billing_table_message"),
      dataIndex: getBillContentKey,
      key: getBillContentKey,
      render: (_: any, row: IBillingMessageInfoItem) => (
        <NotificationMonthContent isRead={!!row.isRead}>
          {currentNotificationTab === NotificationTabType.BillingMessage
            ? t("notification_billing_table_content", {
                year: new Date(row.billMonth).getFullYear(),
                month: new Date(row.billMonth).getMonth() + 1,
              })
            : row[getBillContentKey]}
        </NotificationMonthContent>
      ),
    },
    {
      title: t("notification_billing_table_time"),
      dataIndex: "createTime",
      key: "createTime",
      width: "40%",
      render: (_: any, row: IBillingMessageInfoItem) => (
        <NotificationContent isRead={!!row.isRead}>
          {dateFormatter(row.createTime)}
        </NotificationContent>
      ),
    },
    {
      title: t("notification_billing_table_operate"),
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (_: any, row: IBillingMessageInfoItem) => {
        return <OperationButton operation={Operation.Delete} />;
      },
    },
  ];
  return columns;
}
